

exports.__esModule = true;
exports.$AddTaxIdRoute = undefined;

require('./directive');

var _squid = require('squid');

var $AddTaxIdRoute = exports.$AddTaxIdRoute = _squid.$ComponentRoute.extend('$AddTaxIdRoute', {

    path: 'addTaxId',
    directive: 'xo-add-tax-id-page',
    titleContent: 'addTaxId.addTaxId',
    query: ['message'],
    trackingData: {
        templateName: 'addTaxId.dust',
        pageGoal: 'Add Tax Id',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-add-tax-id',
                'pagename2': '%::fullpage-add-tax-id:member:hermes:',
                'version': 'member:%:'
            }
            // More page qualifiers come here...
        }
    },
    loginRequired: true,
    children: []
});

angular.value("$AddTaxIdRoute", $AddTaxIdRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-tax-id/route.js
// module id = ./pages/xo-add-tax-id/route.js
// module chunks = 1